import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["type", "placeholder", "name", "id", "required", "pattern", "value", "disabled"]

import { computed, onMounted, PropType, ref } from "vue";
import { IUmbracoFormField } from "@/models/umbraco-forms/IUmbracoFormField";
import { InputState } from "@/models/umbraco-forms/InputState";
import { InputErrorState } from "@/models/umbraco-forms/InputErrorState";


export default /*#__PURE__*/_defineComponent({
  __name: 'UmbracoFormInput',
  props: {
  field: {
    type: Object as PropType<IUmbracoFormField>,
    required: true,
  },
  type: {
    type: String,
    required: true,
  },
  id: {
    type: String,
    required: true,
  },
  value: {
    type: String,
    required: true,
  },
},
  emits: {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  stateChanged: (state: InputState) => true,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  invalid: (errorState: InputErrorState) => true,
},
  setup(__props, { emit }) {

const props = __props;



const state = ref<InputState>(
  InputState.Pristine | InputState.Invalid | InputState.Untouched | InputState.Empty | InputState.Blurred
);

if (props.value || props.field?.settings.defaultValue) {
  state.value &= ~InputState.Empty;
}
const onFocus = () => {
  state.value &= ~(InputState.Untouched | InputState.Blurred);
  emit("stateChanged", state.value);
};
const onBlur = (ev: Event) => {
  state.value |= InputState.Blurred;
  emit("stateChanged", state.value);
  checkValidity((ev.target as HTMLObjectElement).validity);
};
const onInput = (ev: Event) => {
  state.value &= ~InputState.Pristine;
  if ((ev.target as HTMLInputElement).value) {
    state.value &= ~InputState.Empty;
  } else {
    state.value |= InputState.Empty;
  }
  emit("stateChanged", state.value);
};
const onInvalid = (ev: Event) => {
  ev.preventDefault();
  checkValidity((ev.target as HTMLObjectElement).validity);
};
const checkValidity = (validity: ValidityState) => {
  let errorState = InputErrorState.None;
  if (validity.valueMissing) {
    errorState |= InputErrorState.Required;
  }
  if (validity.patternMismatch) {
    errorState |= InputErrorState.Pattern;
  }
  emit("invalid", errorState);
};

const defaultValue = computed(() => {
  if (props.field?.settings.defaultValue && props.field.settings.defaultValue.startsWith("@")) {
    return null;
  }
  return props.field?.settings.defaultValue;
});
onMounted(() => {
  emit("stateChanged", state.value);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("input", {
    type: __props.field.settings.fieldType || __props.type,
    placeholder: __props.field.placeholder || undefined,
    name: __props.field.alias,
    id: __props.id || __props.field.id,
    required: __props.field.required,
    pattern: __props.field.pattern || undefined,
    onFocus: onFocus,
    onInput: onInput,
    onBlur: onBlur,
    onInvalid: onInvalid,
    value: __props.value || defaultValue.value,
    disabled: __props.field.settings.showLabel == 'False'
  }, null, 40, _hoisted_1))
}
}

})